class PaymentsListController {
	constructor(PaymentsFactory, MiscFactory, $filter, ngDialog, $state){
		'ngInject';
		const vm = this;

		let $translate = $filter('translate');

		vm.$onInit = () =>{
			vm.years = [];
			MiscFactory.getYears().then(response => {
				vm.years = response.data;
			});
			reloadPayments();
		};

		vm.gridOptions = {
			enableSorting: true,
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [
				{
					field: 'name',
					displayName: $translate('NAME'),
					enableFiltering: true,
				}, {
					field: 'year.year',
					displayName: $translate('YEAR'),
					enableFiltering: true,
					width: '100'
				}, {
					field: 'actions',
					enableFiltering: false,
					name: $translate('ACTIONS'),
					headerCellClass: 'text-center',
					cellTemplate: '' +
					'<div ' +
					'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
					'<div class="buttons">' +
					'<button class="btn btn-sm btn-warning" translate ' +
					'data-toggle="modal" ' +
					'data-target="#paymentModel" ' +
					'ng-click="grid.appScope.vm.openPaymentModal(row.entity)">EDIT</button> ' +
					'<button class="btn btn-sm btn-danger" translate ' +
					'ng-click="grid.appScope.vm.deletePayment(row.entity.id)">DELETE</button> ' +
					'</div>' +
					'</div>',
					width: '340',
				},
			],
		};

		/* Modal */
		vm.openPaymentModal = (payment) =>{
			vm.payment = {};
			if(payment){
				angular.copy(payment, vm.payment);
				vm.payment.required_team = (vm.payment.required_team === 1);
				vm.payment.required_player = (vm.payment.required_player === 1);
			}
		};

		vm.submit = () =>{
			vm.payment.required_team = vm.payment.required_team ? 1 : 0;
			vm.payment.required_player = vm.payment.required_player ? 1 : 0;
			if(vm.payment.id){
				PaymentsFactory.updatePaymentItem(vm.payment.id, vm.payment).then(response => {
					ngDialog.open({template: 'successTemplate'});
					reloadPayments();
				});
			}else{
				PaymentsFactory.createPaymentItem(vm.payment).then(response => {
					ngDialog.open({template: 'successTemplate'});
					reloadPayments();
				});
			}
		};

		vm.deletePayment = (paymentId) => {
			ngDialog.openConfirm({
				template: 'confirmTemplate',
				data: {
					message: $translate('CONFIRM_DELETE_PAYMENT')
				}
			}).then(() => {
				PaymentsFactory.deletePaymentItem(paymentId).then(response => {
					ngDialog.open({template: 'successTemplate'});
					reloadPayments();
				});
			});
		};

		function reloadPayments(){
			PaymentsFactory.getAll().then(response =>{
				vm.gridOptions.data = response.data;
			});
		}
	}
}

export default PaymentsListController;



// WEBPACK FOOTER //
// ./client/app/components/payments/paymentsList/paymentsList.controller.js